import React from "react";
import { Field, useFormikContext } from "formik";
import Select from "react-select";
import moment from "moment";
import { api } from "../../redux/apis/api";
import { url } from "../../redux/config";

const ChangeBatchField = ({
  rowIndex,
  disabled,
  setIsLoadingOverlay,
  rowData,
}) => {
  const { values, setFieldValue } = useFormikContext();

  const selectedBatchNumbers = values.data
    .filter((_, index) => index !== rowIndex)
    .map((row) => row?.item_batch_number);

  const handleBatchChange = async (sel) => {
    setIsLoadingOverlay(true);
    const updatedData = [...values?.data];
    const totalAmount =
      parseFloat(values?.data?.[rowIndex]?.quantity) *
      parseFloat(sel?.item_selling_price);
    const quantityForOriginal =
      parseFloat(values?.data?.[rowIndex]?.quantity) || 0;
    const unitPriceForOriginal =
      parseFloat(sel?.item_unit_price) ||
      parseFloat(values?.data?.[rowIndex]?.item_unit_price) ||
      0;
    const totalAmountofOriginalPrice =
      quantityForOriginal * unitPriceForOriginal;
    try {
      const response = await api.get(
        `${url}/discount/get?totalAmountofOriginalPrice=${totalAmountofOriginalPrice}&totalAmountOfItem=${totalAmount}&item_quantity=${values?.data?.[rowIndex]?.quantity}&item_id=${values?.data?.[rowIndex]?.item_id}&cmr_phone_number=${values?.phone?.label}&batchNumber=${sel?.value}`
      );

      if (response.data?.code === 200) {
        const discount =
          parseFloat(response.data?.data?.item_discount_amount) || 0;
        const tax = parseFloat(response.data?.data?.item_tax_amount) || 0;
        const item_discount_percentage =
          parseFloat(response.data?.data?.item_discount_percentage) || 0;
        const item_total_tax_percentage =
          parseFloat(response.data?.data?.item_total_tax_percentage) || 0;
        const item_margin_percentage=parseFloat(response.data?.data?.item_margin_percentage) || 0;
        const item_price_without_tax = (
          parseFloat(sel?.item_selling_price) *
            parseFloat(values?.data?.[rowIndex]?.quantity) -
            tax || 0
        ).toFixed(2);
       console.log(item_price_without_tax, "item_price_without_tax",sel?.item_selling_price );
        const item_final_price = (
          (parseFloat(sel?.item_selling_price) *
            parseFloat(values?.data?.[rowIndex]?.quantity)) /
          parseFloat(values?.data?.[rowIndex]?.quantity)
        ).toFixed(4);

        const updatedDataRow = {
          ...updatedData[rowIndex],
          item_exp_date: moment(
            values.data[rowIndex].itemBatchList?.find(
              (item) => item?.created_date === sel?.created_date
            )?.item_exp_date
          ).format("YYYY-MM-DD"),
          to_bin_id: sel?.to_bin_id,
          item_batch_number: sel?.value,
          item_unit_price: sel?.item_unit_price,
          item_selling_price: sel?.item_selling_price,
          item_rack_location: sel?.item_rack_location,
          item_discount_amount: discount.toFixed(2),
          item_tax_amount: tax.toFixed(2),
          item_discount_percentage: item_discount_percentage,
          item_price_wiithout_tax: item_price_without_tax,
          item_gst: item_total_tax_percentage,
          item_sgst: (tax / 2).toFixed(2),
          item_cgst: (tax / 2).toFixed(2),
          item_igst: 0,
          item_final_price: item_final_price,
          item_total_amount: (
            parseFloat(sel?.item_selling_price) *
              parseFloat(values?.data?.[rowIndex]?.quantity) 
          ).toFixed(2),
          item_total_tax_percentage: item_total_tax_percentage.toFixed(2),
          item_margin_percentage:item_margin_percentage
        };

        updatedData[rowIndex] = updatedDataRow;
        setFieldValue("data", updatedData);

        const sot_total_gst = updatedData.reduce(
          (total, item) => total + parseFloat(item?.item_tax_amount || 0),
          0
        );
        const sot_total_discount = updatedData.reduce(
          (total, item) => total + parseFloat(item?.item_discount_amount || 0),
          0
        );
        const sot_sub_total = updatedData.reduce(
          (subtotal, item) =>
            subtotal +
            parseFloat(item?.item_unit_price || 0) *
              parseFloat(item?.quantity || 0),
          0
        );

        const sot_total_amount = updatedData.reduce(
          (total, item) => total + parseFloat(item?.item_total_amount || 0),
          0
        );

        const rounded_total = Math.round(sot_total_amount);
        const roundoff = (rounded_total - sot_total_amount)?.toFixed(2);

        setFieldValue("sot_total_gst", sot_total_gst.toFixed(2));
        setFieldValue("sot_total_discount", sot_total_discount.toFixed(2));
        setFieldValue("sot_sub_total", sot_sub_total.toFixed(2));
        setFieldValue("sot_total_amount", rounded_total.toFixed(2));
        setFieldValue("sot_round_off", roundoff);
        setFieldValue("sot_invoice_discount", 0);
        setFieldValue("sot_invoice_discount_percentage", 0);
        setFieldValue("sot_is_invoice_dis_percentage", false);
        setFieldValue("header_inv_dis_per", 0);
      }
    } catch (err) {
      console.error("Error during API call:", err);
    } finally {
      setIsLoadingOverlay(false);
    }
  };

  const batchOptions = values.data[rowIndex].itemBatchList
    ?.filter(
      (item) =>
        parseFloat(item?.item_quantity) >= values.data[rowIndex]?.quantity &&
        !selectedBatchNumbers.some(
          (batch, index) =>
            values.data[index]?.item_id === values.data[rowIndex]?.item_id &&
            batch === item?.item_batch_number
        )
    )
    .map((item) => ({
      label: (
        <div className="flex flex-col">
          <span>Avail Qty: {item?.item_quantity}</span>
          <span>Btch Num: {item?.item_batch_number}</span>
        </div>
      ),
      value: item?.item_batch_number,
      to_bin_id: item?.to_bin_id,
      created_date: item?.created_date,
      item_rack_location: item?.item_rack_location,
      item_unit_price: (
        item?.item_unit_price / (parseFloat(item?.base_quantity) || 1)
      ).toFixed(2),
      item_selling_price: (
        item?.item_selling_price / (parseFloat(item?.base_quantity) || 1)
      ).toFixed(4),
    }));

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, minWidth: "15rem" }),
    indicatorSeparator: () => ({ display: "none" }),
    control: (base, state) => ({
      ...base,
      backgroundColor: `${
        rowIndex % 2 === 0
          ? " bg-[var(--create-table-row-alt-bg)]"
          : " bg-[var(--create-table-row-bg)]"
      }`,
      color: "var(--create-table-row-fg-color)",
      fontSize: "var(--create-table-row-font-size)",
      fontWeight: "var(--create-table-row-font-weight)",
      // borderColor: state.isFocused
      //   ? "var(--create-table-row-bg)"
      //   : "var(--create-table-row-bg)",
      boxShadow: "none",
      border: "none",
      borderRadius: "6px",
      padding: "0",
      margin: "0",
      minHeight: "40px",
      "&:hover": {
        backgroundColor: "var(--create-table-row-hover-bg)",
      },
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "3px 6px",
    }),

    option: (provided, state) => ({
      ...provided,
      color: "var(--create-table-row-fg-color)",
      backgroundColor: state.isSelected
        ? "var(--create-table-row-hover-bg)"
        : state.isFocused
        ? "#0000002E"
        : "transparent",
      borderBottom: "1px solid #F5F5F5",
      fontFamily: "Inter, sans-serif",
      fontSize: "var(--create-table-row-font-size)",
      fontWeight: "var(--create-table-row-font-weight)",
      "&:hover": {
        backgroundColor: "#0000002E",
      },
    }),

    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      color: "#737373",
      fontFamily: "Inter, sans-serif",
      fontSize: "var(--create-table-row-font-size)",
      fontWeight: "var(--create-table-row-font-weight)",
      opacity: "0.9",
    }),

    singleValue: (base) => ({
      ...base,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: "var(--create-table-row-fg-color)",
      fontSize: "var(--create-table-row-font-size)",
      fontWeight: "var(--create-table-row-font-weight)",
    }),

    multiValue: (base) => ({
      ...base,
      backgroundColor: "#E5ECFF",
      gap: "5px",
      padding: "0px 6px",
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0 5px",
      fontSize: "12px",
      transform: "scale(0.8)",
    }),
  };

  return (
    <Field name={`data[${rowIndex}].item_batch_number`}>
      {({ form, meta, Field }) => {
        return (
          <Select
            menuPortalTarget={document.body}
            menuPlacement="auto"
            value={{
              label: rowData?.item_batch_number,
              value: rowData?.item_batch_number,
            }}
            onChange={handleBatchChange}
            options={batchOptions}
            isDisabled={disabled}
            placeholder="Select Batch Number"
            styles={customStyles}
          />
        );
      }}
    </Field>
  );
};

export default ChangeBatchField;
